import {
  StatesConfig,
  LlmProvider,
  type LLMsViewType,
  VIEW_TYPE_LABELS,
} from "@intone/shared";

export const SINGLE_STATE_CONFIG: StatesConfig = {
  'Agent LLM': {
    prompt: '',
    tools: [],
    is_initial: true,
  },
};

export const MULTI_STATE_CONFIG: StatesConfig = {
  'Starting LLM state': {
    prompt: '',
    tools: [],
    is_initial: true,
    transition: {
      to: 'Main LLM state',
      type: 'number_of_turns',
      number_of_turns: 3,
    },
  },
  'Main LLM state': {
    prompt: '',
    tools: [],
  },
};

export const MODEL_OPTIONS = [
  { value: 'gpt-4.1', label: 'GPT-4.1', provider: 'azure-openai' as LlmProvider, enabled: true },
  { value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini', provider: 'azure-openai' as LlmProvider, enabled: true },
  { value: 'gpt-4.1-nano', label: 'GPT-4.1 Nano', provider: 'azure-openai' as LlmProvider, enabled: true },
  { value: 'gpt-5.1', label: 'GPT-5.1', provider: 'azure-openai' as LlmProvider, enabled: true },
  { value: 'gpt-5.1-mini', label: 'GPT-5.1 Mini', provider: 'azure-openai' as LlmProvider, enabled: true },
  { value: 'mercury-coder-small', label: 'Inception', provider: 'inception' as LlmProvider, enabled: true },
  { value: 'mercury-coder-small-v2', label: 'Inception v2', provider: 'inception' as LlmProvider, enabled: true },
  { value: 'claude-sonnet-4', label: 'Claude Sonnet 4', provider: 'anthropic' as LlmProvider, enabled: true },
  { value: 'claude-haiku-4', label: 'Claude Haiku 4', provider: 'anthropic' as LlmProvider, enabled: true },
  { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash', provider: 'google' as LlmProvider, enabled: true },
  { value: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro', provider: 'google' as LlmProvider, enabled: true },
] as const;

export const DEFAULT_MODEL = 'gpt-4.1-mini';
export const DEFAULT_PROVIDER: LlmProvider = 'azure_openai'

export const VIEW_TYPE_LABELS_MAP: Record<LLMsViewType, string> = VIEW_TYPE_LABELS;

export const DEFAULT_EVAL_FORMAT = `Start your OUTPUT with PASS or FAIL

- If it's fail, give a short explanation what went wrong
- If it's a pass, don't output anything`;